@if (state.isLoading) {
  <div class="flex h-full items-center justify-center">
    <dojo-loader />
  </div>
} @else if (state.source) {
  <as-split
    @appearDisappear
    [direction]="'horizontal'"
    unit="pixel"
    class="h-full"
    [gutterSize]="1"
    [useTransition]="true"
  >
    <as-split-area [size]="'*'" [minSize]="400">
      <exam-detail-view-wrapper>
        <ng-container title>
          <div class="flex items-center justify-between pl-4 pr-1">
            <span> Source: {{ state.source.name }} </span>
            <div class="flex gap-4">
              <dojo-button
                [size]="'xs'"
                [customColor]="'sky'"
                [disabled]="sourceForm.pristine || sourceForm.invalid"
                [pending]="isSaving()"
                (click)="saveMainForm()"
              >
                <div class="flex items-center gap-1.5">
                  <dojo-icon [icon]="'save'" />
                  <span>Save</span>
                </div>
              </dojo-button>
            </div>
          </div>
        </ng-container>

        <div class="scrollbar-gutter-stable h-full overflow-y-auto pl-2">
          <dojo-source-editor [source]="state.source" />
        </div>

        <ng-container sidebar>
          <mat-button-toggle-group
            class="custom-toggle-group size-s"
            hideSingleSelectionIndicator
            [value]="sidebarTabs()"
            (change)="sidebarTabs.set($event.value)"
          >
            <mat-button-toggle [value]="'details'">Details</mat-button-toggle>
            <mat-button-toggle [value]="'reference-questions'">Reference Questions</mat-button-toggle>
          </mat-button-toggle-group>

          @if (sidebarTabs() === 'details') {
            <dojo-source-status-selector [formCtrl]="statusCtrl" [label]="'Status'" />

            <dojo-text-input
              [formCtrl]="sourceForm.controls.id"
              [label]="'Source ID'"
              [readOnly]="true"
              [enableCopyToClipboard]="true"
            />
          } @else {
            <exam-scoped-reference-question-list [sourceId]="state.source.id" />
          }
        </ng-container>
      </exam-detail-view-wrapper>
    </as-split-area>
    <as-split-area [size]="600" [minSize]="300" class="flex h-full flex-col">
      <div
        class="text-primary flex min-h-[60px] shrink-0 flex-wrap items-center justify-between gap-2 border-b border-neutral-200 bg-neutral-50 px-4 py-2 text-lg font-semibold"
      >
        <span class="whitespace-nowrap">Original PDFs</span>

        <mat-button-toggle-group
          class="custom-toggle-group size-s"
          hideSingleSelectionIndicator
          [value]="selectedPdfPlace()"
          (change)="changeSelectedPdfPlace($event.value)"
        >
          <mat-button-toggle [value]="'questions'">Question</mat-button-toggle>
          <mat-button-toggle [value]="'markschemes'">Markscheme</mat-button-toggle>
        </mat-button-toggle-group>
      </div>

      <div class="h-full overflow-y-auto overflow-x-hidden">
        @if (state.pdfUrls) {
          @for (pdfUrl of state.pdfUrls[selectedPdfPlace()]; track pdfUrl.path) {
            <dojo-pdf-viewer #pdfViewer [src]="pdfUrl.signedUrl" [name]="pdfUrl.path ?? ''" />
          }
        } @else {
          <div class="flex h-full flex-col items-center justify-center">
            <dojo-loader />
          </div>
        }
      </div>
    </as-split-area>
  </as-split>
} @else {
  Source not found
}
